module.exports = __webpack_public_path__ + "img/samplec.98cef4d9.png";